<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>Claim Dashboard</span>
    </fury-title>
</fury-page>

<fury-page  class="dashboard" fxLayout="column">
      <div fxLayout="column" fxLayoutAlign="center center">
        <div class="dashboardbody">
            <div class="innerdashbody partnerbody parner-dash">
                <div class="tab-wrap">
                    <mat-tab-group animationDuration="0ms" (selectedTabChange)="tabChange($event)">
                        <mat-tab [label]="tabNameList.myClaims">
                            <div class="header-section">     
                            <div class="kpi_section">
                            <fury-common-kpi-blocks [mainPage]="'claims'" [data]="kpiData"></fury-common-kpi-blocks>
                            </div>
                        <div class="rangeselectorprt">
                            <span>
                                <div class="daterange">
                                    <mat-form-field class="example-form-field" appearance="outline">
                                    <mat-label>Date Range</mat-label>
                                        <mat-date-range-input
                                        [formGroup]="dateRangeForm"
                                        [rangePicker]="campaignOnePicker"
                                        [max]="today" (click)="campaignOnePicker.open()">
                                        <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart readonly>
                                        <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)" readonly>
                                        </mat-date-range-input>
                                        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
                                        <mat-date-range-picker #campaignOnePicker>
                                            <mat-date-range-picker-actions>
                                                <button class="apply" mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                                                <button class="clear" mat-button matDateRangePickerCancel *ngIf="startDate && endDate" (click)="clearDateRange()">Clear</button>
                                                <button class="can" mat-button matDateRangePickerCancel>Cancel</button>
                                            </mat-date-range-picker-actions>
                                        </mat-date-range-picker>
                                    </mat-form-field>
                                </div>
                            </span>
                        </div>
                            </div>
                            <fury-claim-table [dataSource]="itemList" [searchForm]="claimSearchForm" [services]="services" (fetchClaimData)="fetchClaimData($event)"></fury-claim-table>
                            <mat-paginator *ngIf="itemList?.length > 0" [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)" showFirstLastButtons [selectConfig] = "selectConfig" [ngClass]="{'mat-pegig': pageSize === 9999}"  aria-label="Select page of periodic elements">
                            </mat-paginator>  
                        </mat-tab>
                        <mat-tab [label]="tabNameList.openClaims">
                            <fury-claim-table [dataSource]="itemList" [searchForm]="claimSearchForm" [services]="services"  (fetchClaimData)="fetchClaimData($event)"></fury-claim-table>
                            <mat-paginator *ngIf="itemList?.length > 0" [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)" showFirstLastButtons [selectConfig] = "selectConfig" [ngClass]="{'mat-pegig': pageSize === 9999}"  aria-label="Select page of periodic elements">
                            </mat-paginator>  
                        </mat-tab>
                        <mat-tab [label]="tabNameList.purchaseClaim">
                            <fury-purchase-claim [claimUserId]="claimUserId" [tabName]="tabName" [pageIndex]="pageIndex"></fury-purchase-claim>
                        </mat-tab>
                        <mat-tab [label]="tabNameList.payoutClaims">
                            <fury-payout-claim [claimUserId]="claimUserId" [tabName]="tabName" [pageIndex]="pageIndex"></fury-payout-claim>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>
      </div>
</fury-page>
